<template>
	<div class="zzgk_dialog">
		<el-dialog 
			:modal-append-to-body='true'
			width="400px"
			center
			:append-to-body='true'
			@close="closeTagWin"
			:visible.sync="tagsWin">
			<div slot="title" class="addtitle">
				<div>
					<i class="icon adddzz"></i>
					自定义标签
					<div class="addline"></div>
				</div>
			</div>
			<div class="formData1">
				<el-form :model="formData" :rules="rules" ref="formData" label-width="100px" class="demo-ruleForm">
					<el-form-item label="标签名称" prop="tags">
						<el-input v-model="formData.tags"  placeholder="输入标签名称" autocomplete="off"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit()">保存并选中</el-button>
				<el-button @click="closeTagWin">取消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { Message } from 'element-ui'
	let that;
	export default{
		data(){
			return{
				formData:{
					tags:""
				},
				rules:{
					tags:[{ required: true, message: '请输入标签名称', trigger: 'blur' }],
				},
			}
		},
		props:{
			tagsWin:{
				type:Boolean,
				default:false
			}
		},
		created() {
			that = this;
		},
		methods:{
			// 提交表单
			submit(){
				that.$refs.formData.validate(valid => {
					if(valid){
						that.$emit('addtgs',{
							name:that.formData.tags,
							del:true,
							checked:true
						});
					}else{
						return false;
					}
				})
			},
			// 清除表单
			closeTagWin(){
				that.$emit('closeTagWin');
				that.$refs.formData.resetFields();
			}
		}
	}
</script>

<style lang="scss">
	.zzgk_dialog{
		.el-dialog{
			z-index: 1000;
			width: 500px;
		}
	}
</style>
